import React from 'react';
import './ViaviLogo.css';

const ViaviLogo = () => (
  <svg id="viavi-logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 464.78 465">
    <polygon className="cls-2 triangle delay-1" points="70.11 233.15 140.22 117.23 0 117.23 70.11 233.15"/>
    <polygon className="cls-1 triangle delay-2" points="140.22 117.23 70.11 233.15 210.33 233.15 140.22 117.23"/>
    <polygon className="cls-4 triangle delay-3" points="140.22 349.08 210.33 233.15 70.11 233.15 140.22 349.08"/>
    <polygon className="cls-9 triangle delay-4" points="210.33 465 280.44 349.08 140.22 349.08 210.33 465"/>
    <polygon className="cls-5 triangle delay-5" points="210.33 233.15 140.22 349.08 280.44 349.08 210.33 233.15"/>
    <polygon className="cls-6 triangle delay-6" points="280.44 349.08 350.55 233.15 210.33 233.15 280.44 349.08"/>
    <polygon className="cls-3 triangle delay-7" points="280.44 117.23 210.33 233.15 350.55 233.15 280.44 117.23"/>
    <polygon className="cls-8 triangle delay-8" points="245.38 0 210.33 57.96 280.44 57.96 245.38 0"/>
    <polygon className="cls-7 triangle delay-9" points="394.67 144.9 464.78 28.98 324.56 28.98 394.67 144.9"/>
  </svg>
);

export default ViaviLogo;
